<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>资产订单</span>
        <div>
          <el-button type="primary" size="small" @click="_goBack">
            <i class="el-icon-close"></i> 返回
          </el-button>
        </div>
      </div>
      <div class="form-content">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="form-item">
              <label>选择仓库</label>
              <div>{{assetInventoryInStockInfo.shName}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="form-item">
              <label>盘点日期</label>
              <div>{{assetInventoryInStockInfo.invTime}}</div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="form-item">
              <label>盘点说明</label>
              <div>{{assetInventoryInStockInfo.remark}}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="flex justify-between">
        <span>入库商品</span>
      </div>
      <el-table
        :data="assetInventoryInStockInfo.inoutOrderProducts"
        border
        style="width: 100%">
        <el-table-column prop="productId" label="编号" align="center"></el-table-column>
        <el-table-column prop="prodName" label="名称" align="center"></el-table-column>
        <el-table-column prop="specName" label="规格" align="center"></el-table-column>
        <el-table-column prop="price" label="单价" align="center"></el-table-column>
        <el-table-column prop="quantity" label="账面数量" align="center"></el-table-column>
        <el-table-column prop="invQuantity" label="盘点数量" align="center"></el-table-column>
        <el-table-column prop="willExpire" label="将过期" align="center"></el-table-column>
        <el-table-column prop="attrition" label="耗损" align="center"></el-table-column>
        <el-table-column prop="invProfit" label="盘盈" align="center"></el-table-column>
        <el-table-column prop="invLoss" label="盘亏" align="center"></el-table-column>
        <el-table-column prop="invProfitMoney" label="盘盈金额" align="center"></el-table-column>
        <el-table-column prop="invLossMoney" label="盘亏金额" align="center"></el-table-column>
        <el-table-column prop="stateName" label="状态" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.state != '4466'"
              type="text"
              size="small"
              @click="_inStock(scope.row.detailId)">
              入库
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <div class="action-buttons">
      <el-button type="warning" @click="_goBack" style="margin-right: 20px;">
        <i class="el-icon-close"></i> 取消
      </el-button>
      <el-button type="primary" @click="_inStock">
        <i class="el-icon-check"></i> 批量入库
      </el-button>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryAssetInventory, queryAssetInventoryProduct, assetInventoryInStock } from '@/api/goods/assetInventoryInStockApi'

export default {
  data() {
    return {
      assetInventoryInStockInfo: {
        aiId: '',
        shId: '',
        shName: '',
        invTime: '',
        inoutOrderProducts: [],
        remark: '',
        shopId: ''
      }
    }
  },
  created() {
    this.assetInventoryInStockInfo.aiId = this.$route.query.aiId
    this._queryAssetInventory()
    this.queryAssetInventoryProduct()
  },
  methods: {
    async _inStock(_detailId) {
      let _products = []
      if (_detailId) {
        _products.push({
          detailId: _detailId,
          shopId: getShopId()
        })
      } else {
        this.assetInventoryInStockInfo.inoutOrderProducts.forEach(item => {
          if (item.state != '4466') {
            _products.push({
              detailId: item.detailId,
              shopId: getShopId()
            })
          }
        })
      }
      if (_products.length < 1) {
        this.$message.warning('没有待入库的商品')
        return
      }
      let _data = {
        aiId: this.assetInventoryInStockInfo.aiId,
        shopId: getShopId(),
        products: _products
      }
      
      try {
        const res = await assetInventoryInStock(_data)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this._goBack()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error('请求失败')
        console.error(error)
      }
    },
    _goBack() {
      this.$router.go(-1)
    },
    async _queryAssetInventory() {
      const params = {
        page: 1,
        row: 1,
        aiId: this.assetInventoryInStockInfo.aiId,
        shopId: getShopId()
      }
      
      try {
        const res = await queryAssetInventory(params)
        Object.assign(this.assetInventoryInStockInfo, res.data[0])
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async queryAssetInventoryProduct() {
      const params = {
        page: 1,
        row: 100,
        aiId: this.assetInventoryInStockInfo.aiId,
        shopId: getShopId()
      }
      
      try {
        const res = await queryAssetInventoryProduct(params)
        res.data.forEach(item => {
          this._computeData(item)
        })
        this.assetInventoryInStockInfo.inoutOrderProducts = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _computeData(_inoutOrderProduct) {
      _inoutOrderProduct.invProfit = parseInt(_inoutOrderProduct.invQuantity) - parseInt(_inoutOrderProduct.quantity)
      if (_inoutOrderProduct.invProfit < 0) {
        _inoutOrderProduct.invProfit = 0
      }
      _inoutOrderProduct.invLoss = parseInt(_inoutOrderProduct.quantity) - parseInt(_inoutOrderProduct.invQuantity)
      if (_inoutOrderProduct.invLoss < 0) {
        _inoutOrderProduct.invLoss = 0
      }
      _inoutOrderProduct.invProfitMoney = _inoutOrderProduct.invProfit * parseFloat(_inoutOrderProduct.price)
      _inoutOrderProduct.invLossMoney = _inoutOrderProduct.invLoss * parseFloat(_inoutOrderProduct.price)
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.form-content {
  padding: 20px;
}
.form-item {
  margin-bottom: 20px;
}
.form-item label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.action-buttons {
  margin-top: 20px;
  text-align: right;
}
</style>